import {
  getCountryFromLocaleIdentifier,
  getLanguageFromLocaleIdentifier,
} from 'util/getCountryFromLocaleIdentifier';

export const formatLocaleWithUppercaseCountry = (locale: string): string => {
  const language = getLanguageFromLocaleIdentifier(locale);
  const country = getCountryFromLocaleIdentifier(locale);

  return `${language || 'en'}-${country?.toUpperCase() || 'DE'}`;
};
